import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ActiveTableResponseType, GetAddressesResponseType } from '../../api/api.types';
import { showErrorMessage } from '../../utils/handleErrors';
import addressApi from '../../api/addressApi';

const getAddressesByPostcode = createAsyncThunk<
  GetAddressesResponseType,
  { postcode: string; apiKey: string }
>(
  'address/getAddressesByPostcode',
  async (params: { postcode: string; apiKey: string }, { rejectWithValue }) => {
    try {
      const response = await addressApi.getAddressesByPostcode(params);

      return response.data;
    } catch (error) {
      showErrorMessage(error);
      return rejectWithValue(error);
    }
  },
);

const getAddressesByText = createAsyncThunk<
  GetAddressesResponseType,
  { text: string; apiKey: string }
>(
  'address/getAddressesByText',
  async (params: { text: string; apiKey: string }, { rejectWithValue }) => {
    try {
      const response = await addressApi.getAddressesByText(params);

      return response.data;
    } catch (error) {
      showErrorMessage(error);
      return rejectWithValue(error);
    }
  },
);

const getAddressesByTextOrPostcode = createAsyncThunk<
  GetAddressesResponseType,
  { text: string; apiKey: string }
>(
  'address/getAddressesByTextOrPostcode',
  async (params: { text: string; apiKey: string }, { rejectWithValue }) => {
    try {
      const response = await addressApi.getAddressesByTextOrPostcode(params);

      return response.data;
    } catch (error) {
      showErrorMessage(error);
      return rejectWithValue(error);
    }
  },
);

const clearReverseTable = createAsyncThunk(
  'address/clearReverseTable',
  async (_, { rejectWithValue }) => {
    try {
      await addressApi.clearReverseTable();
    } catch (error) {
      showErrorMessage(error);
      return rejectWithValue(error);
    }
  },
);

const toggleTable = createAsyncThunk<ActiveTableResponseType>(
  'address/toggleTable',
  async (_, { rejectWithValue }) => {
    try {
      const response = await addressApi.toggleTable();

      return response.data;
    } catch (error) {
      showErrorMessage(error);
      return rejectWithValue(error);
    }
  },
);

const getActiveTableInfo = createAsyncThunk<ActiveTableResponseType>(
  'address/getActiveTableInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await addressApi.getActiveTableInfo();

      return response.data;
    } catch (error) {
      showErrorMessage(error);
      return rejectWithValue(error);
    }
  },
);

const clearQueue = createAsyncThunk('address/clearQueue', async (_, { rejectWithValue }) => {
  try {
    await addressApi.clearQueue();
  } catch (error) {
    showErrorMessage(error);
    return rejectWithValue(error);
  }
});

export default {
  getAddressesByPostcode,
  getAddressesByText,
  getAddressesByTextOrPostcode,
  getActiveTableInfo,
  toggleTable,
  clearReverseTable,
  clearQueue,
};
